<div class="sign-new">
<div class="login-section sign-new">
        <!--<div class="login-logo">
		 <h2><img src="/assets/images/head_logo.png"></h2>
		</div>-->
	 <div class="login-form-sec">
        <div class="form-section above-half">
		    <h2>Free Join</h2>
            <!--<form (ngSubmit)="doAdd(fm)" #fm="ngForm">-->
            <form> 
                <div class="">
                    <div class="form-group">
                        <label>Email</label>
                        <input name="email" type="text" class="form-control">
                       
                    </div>
                    <div class="form-group">
                        <label>Password</label>
                        <input name="password" type="password" class="form-control" >
                        <span class="error_message"></span>
                    </div>
                </div>
                <div class="form-group submit-group">
                    <button type="submit" class="btn btn-login">Sign Up for free</button>
                </div>
                <p class="or-divider login_button">or</p>
                <div class="form-group submit-group">
                    <a class="btn btn-create" routerLink="/login">Already a User? Login</a>
                </div>
            </form>
        </div>
    </div>
</div>
</div>
